import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

export const useBffApi = <T, I, J>(fn: I): J => {
  return useMutation<T, AxiosError, T>(fn) as J;
};
